// @flow

import * as React from 'react';

import FirstLoadController from '../../components/FirstLoadController';
import Orders from './Orders';

type Props = {
  active: boolean,
};

export default function(props: Props) {
  return (
    <FirstLoadController active={props.active}>
      <Orders {...props} />
    </FirstLoadController>
  );
}
